/**
 * Sprawdza, czy dwa zakresy dat nakładają się na siebie.
 * @param start1 Początek pierwszego zakresu
 * @param end1 Koniec pierwszego zakresu
 * @param start2 Początek drugiego zakresu
 * @param end2 Koniec drugiego zakresu
 * @returns true jeśli zakresy się nakładają, false w przeciwnym razie
 */
export function DoDateRangesOverlap(
    start1: Date,
    end1: Date,
    start2: Date,
    end2: Date
): boolean
{
    return start1 <= end2 && start2 <= end1;
}
